import React, { useEffect, useState } from "react"
import { Input, Button, Table, Space, Modal, Form, Popconfirm } from 'antd'
import { SearchOutlined, RedoOutlined, MinusCircleOutlined, PlusOutlined } from '@ant-design/icons'
import { axiosTable, baseAxiosComplete, baseAxiosNoInfo } from "../../tool/axios"
import BreadCrumb from '../../component/BreadCrumb'
import { SelecSupplier } from "../../component/common/Selects"
import { formItemLayout, tailLayout } from '../../js/globalParam'
import _ from 'lodash'

const { Column } = Table

type fetchParams = {
    supply_id: string | undefined
    specs_name: string | undefined
}

type pagination = {
    current: number,
    pageSize: number,
    total: number,
    showSizeChanger: false
}

export default function () {

    let activeRecord: any = {}

    let fetchOtherParamsTmpl: fetchParams = {
        supply_id: undefined,
        specs_name: undefined
    }

    const [userData, setUserData] = useState<any>({ user_name: '', is_admin: '' })

    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(fetchOtherParamsTmpl)
    const [pagination, setPagination] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: false
    })

    // 列表数据
    const [data, setData] = useState<any>([])
    // 列表Loading
    const [loading, setLoading] = useState<boolean>(false)

    const [addVisible, setAddVisible] = useState<boolean>(false)
    const [editVisible, setEditVisible] = useState<boolean>(false)

    const [form] = Form.useForm()
    const [editForm] = Form.useForm()

    useEffect(() => {
        let data: any = localStorage.getItem('userData')
        let d = JSON.parse(data)
        setUserData(d)

        fetch({ pagination, fetchOtherParams })
    }, [pagination.current])

    const handleChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value

        setFetchOtherParams(params)
    }

    const handleInputChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value

        setFetchOtherParams(params)
    }

    const handleSearch = () => {
        const p = { ...pagination }
        p.current = 1

        fetch({ pagination: p, fetchOtherParams })
    }

    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current

        setPagination(p)
    }

    const handleShowEdit = (record: any) => {
        activeRecord = record

        let supply_id = record.supply_id
        let specs_name = record.specs_name

        baseAxiosNoInfo('/mall_center/config/specs/detail', {
            params: {
                supply_id,
                specs_name
            }

        }).then((res: any) => {
            if (res) {
                editForm.setFieldsValue({
                    supply_id: res[0].supply_id,
                    specs_name,
                    specs_values: res.map(({ specs_id, specs_value }: any) => ({ id: specs_id, val: specs_value, is_delete: 1 }))
                })

                setEditVisible(true)
            }
        })
    }

    const fetch = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
        setLoading(true)

        let iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        axiosTable.get('/mall_center/config/specs/page_list', {
            params: {
                ...iPagination,
                ...fetchOtherParams
            }

        }).then((response: any) => {
            let p: any = { ...pagination }
            p.total = response.total

            setPagination(p)
            setData(response.records)

            setLoading(false)
        })
    }

    const resetForm = () => {
        setFetchOtherParams(fetchOtherParamsTmpl)

        let p: any = { ...pagination }
        p.current = 1

        setPagination(p)
        fetch({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl })
    }

    type SpecsValue = {
        "id": string,
        "val": string,
        "is_delete": number
    }

    interface EditSpecsValueProp {
        value?: SpecsValue[]
        onChange?: (e: { id: string, val: string, is_delete: number }[]) => void
    }

    const EditSpecsValue: React.FC<EditSpecsValueProp> = ({ value = [], onChange }) => {

        const [inputValues, setInputValues] = useState<SpecsValue[]>(() => value.map(({ id, val }: any) => ({ id, val, is_delete: 1 })))

        const handleAdd = () => {
            let newArr = [...inputValues]
            newArr.push({ id: '', val: '', is_delete: 1 })

            setInputValues(newArr)
            onChange?.(newArr)
        }

        const handleInputChange = (e: any, index: number) => {
            let newArr = [...inputValues]
            newArr[index].val = e.target.value

            setInputValues(newArr)
            onChange?.(newArr)
        }

        const handleDelete = (index: number) => {
            let newArr = [...inputValues]
            newArr[index].is_delete = 0

            setInputValues(newArr)
            onChange?.(newArr)
        }

        return (
            <div>
                {inputValues.map((el: any, index: number) => <div style={{ marginBottom: 12 }}>
                    {el.is_delete === 1 && <Space>
                        <Input value={el.val} onChange={(e) => { handleInputChange(e, index) }} minLength={1} placeholder="必填" required />
                        <MinusCircleOutlined style={{ marginLeft: 10 }}
                            className="dynamic-delete-button"
                            onClick={() => { handleDelete(index) }}
                        />
                    </Space>}
                </div>)}

                <Button type="dashed" icon={<PlusOutlined />} onClick={handleAdd}>添加规格值</Button>
            </div>
        )
    }

    const onAddFinish = (values: any) => {
        baseAxiosComplete.post('/mall_center/config/specs/add', { id: activeRecord.id, ...values }).then((res: any) => {
            if (res.status === 0) {
                resetForm()
                setAddVisible(false)
            }
        })
    }

    const onEditFinish = (values: any) => {
        activeRecord = {}

        let supply_id = editForm.getFieldValue('supply_id')
        let specs_name = editForm.getFieldValue('specs_name')
        let specs_values = editForm.getFieldValue('specs_values')

        baseAxiosComplete.post('/mall_center/config/specs/update', {
            supply_id,
            specs_name,
            specs_values

        }).then((res: any) => {
            if (res.status === 0) {
                resetForm()
                setEditVisible(false)
            }
        })
    }

    const onConfirmDelete = (record: any) => {
        baseAxiosComplete.post('/mall_center/config/specs/delete', {
            supply_id: record.supply_id,
            specs_name: record.specs_name

        }).then(res => {
            if (res.status === 0) {
                resetForm()
            }
        })
    }

    return (<div className="common-page">
        {/* 商城中心 -> 配置管理 -> 规格管理 */}
        <BreadCrumb position={['商城中心', '规格管理']} />

        <div className="common-top-form">
            <Space direction="horizontal" wrap>
                <div style={{ marginRight: 5, marginBottom: 12 }}>
                    <SelecSupplier value={fetchOtherParams.supply_id} onChange={(v: string) => { handleChange(v, 'supply_id') }} />
                </div>
                <Input style={{ width: '150px', marginRight: 5, marginBottom: 12 }} placeholder="规格名称" onChange={(e: { target: { value: string } }) => { handleInputChange(e.target.value, 'specs_name') }} value={fetchOtherParams.specs_name} />
            </Space>

            <div style={{ marginTop: 10 }}>
                <Button className="search-btn" style={{ marginRight: 12, marginBottom: 12 }} icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>
                <Button style={{ marginRight: 12, marginBottom: 12 }} type="primary" onClick={() => {
                    activeRecord = {};
                    setAddVisible(true);

                    form.setFieldsValue({
                        supply_id: undefined,
                        specs_name: undefined,
                        specs_values: undefined
                    })
                }} >添加</Button>
                <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={resetForm} icon={<RedoOutlined />}>重置</Button>
            </div>
        </div>

        <div className="common-main">
            <Table loading={loading} dataSource={data} scroll={{ x: 'max-content' }} bordered={true} rowKey="specs_id" pagination={pagination} onChange={handleTableChange}>
                <Column title="供应商名称" dataIndex="supply_name" key="supply_name" />
                <Column title="规格名称" dataIndex="specs_name" key="specs_name" />
                <Column title="规格数量" dataIndex="specs_num" key="specs_num" />

                <Column
                    title="操作"
                    key="action"
                    render={(text, record: any) => (
                        <Space size="middle">
                            <Button type="primary" onClick={() => { handleShowEdit(record) }}>编辑</Button>
                            <Popconfirm
                                title="确定删除?"
                                onConfirm={() => { onConfirmDelete(record) }}
                                okText="是"
                                cancelText="否"
                            >
                                <Button>删除</Button>
                            </Popconfirm>
                        </Space>
                    )}
                />
            </Table>
        </div>

        {/* 添加规格 */}
        <Modal title="添加规格" visible={addVisible} width={400} footer={false} onCancel={() => { setAddVisible(false) }}>
            <Form {...formItemLayout} form={form} name="basic" onFinish={onAddFinish}>
                <Form.Item
                    label="供应商"
                    name="supply_id"
                    rules={[{ message: '选择供应商' }]}
                >
                    <SelecSupplier />
                </Form.Item>

                <Form.Item
                    label="规格名称"
                    name="specs_name"
                    rules={[{ required: true, message: '输入规格名称' }, { max: 8, type: 'string' }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label="规格值"
                    required
                >
                    <Form.List
                        name="specs_values"
                        rules={[
                            {
                                validator: async (_, names) => {
                                    if (!names) {
                                        return Promise.reject(new Error('至少填写一个规格值'));
                                    }
                                },
                            },
                        ]}
                    >
                        {(fields, { add, remove }, { errors }) => (
                            <>
                                {fields.map((field, index) => (
                                    <Form.Item required={false} key={field.key}>
                                        <Form.Item
                                            {...field}
                                            validateTrigger={['onChange', 'onBlur']}
                                            rules={[
                                                {
                                                    required: true,
                                                    message: "规格值必填",
                                                },
                                                {
                                                    max: 8,
                                                    type: 'string',
                                                    message: "规格值不能超过8个字符"
                                                }
                                            ]}
                                            noStyle
                                        >
                                            <Input placeholder="规格值" style={{ width: '85%' }} />
                                        </Form.Item>

                                        {fields.length > 1 ? (
                                            <MinusCircleOutlined style={{ marginLeft: 10 }}
                                                className="dynamic-delete-button"
                                                onClick={() => remove(field.name)}
                                            />
                                        ) : null}
                                    </Form.Item>
                                ))}
                                <Form.Item>
                                    <Button type="dashed" onClick={() => add()} style={{ width: '60%' }} icon={<PlusOutlined />}>
                                        添加规格值
                                    </Button>

                                    <Form.ErrorList errors={errors} />
                                </Form.Item>
                            </>
                        )}
                    </Form.List>
                </Form.Item>

                <Form.Item {...tailLayout}>
                    <Space>
                        <Button type="primary" htmlType="submit">提交</Button>
                    </Space>
                </Form.Item>
            </Form>
        </Modal>

        {/* 编辑规格 */}
        <Modal title="编辑规格" visible={editVisible} width={400} footer={false} onCancel={() => { setEditVisible(false) }}>
            <Form {...formItemLayout} form={editForm} name="basic" onFinish={onEditFinish}>
                <Form.Item
                    label="供应商"
                    name="supply_id"
                    rules={[{ message: '选择供应商' }]}
                >
                    <SelecSupplier />
                </Form.Item>

                <Form.Item
                    label="规格名"
                    name="specs_name"
                    rules={[{ required: true, message: '输入规格名' }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label="规格值"
                    required
                    name="specs_values"
                >
                    <EditSpecsValue />
                </Form.Item>

                <Form.Item {...tailLayout}>
                    <Space>
                        <Button type="primary" htmlType="submit">提交</Button>
                    </Space>
                </Form.Item>
            </Form>
        </Modal>
    </div>)
}